import React, { useRef, useEffect, useMemo } from 'react';
import { adressevaelger } from './adressevaelger.esm';
import { withStyles } from '@material-ui/styles';
import flowRight from 'lodash.flowright';
import { injectIntl } from 'react-intl';
import clsx from 'clsx';

import styles from '../styles/dawaAutocomplete';
import CustomIconButton from '../../tableCustomButtons/CustomIconButton';
import withSettings from '../../../utils/withSettings';
import mapAddress from '../actions/mapAddress';
import { DAWA_TOKEN } from '../../../consts/initialValues';

export function DawaAutocomplete({
  classes,
  setValues,
  intl,
  resetForm,
  isDanishAddress,
  settings
}) {
  const inputElem = useRef(null);

  useEffect(() => {
    if (inputElem.current) {
      adressevaelger(inputElem.current, {
        select: selected => {
          const mappedAddress = mapAddress(selected);
          setValues({ ...mappedAddress, isDanishAddress: true });
        },
        token: DAWA_TOKEN
      });
    }
  }, [setValues]);

  const iconCustomStyles = useMemo(() => {
    return {
      color: settings.colors.primary,
      fontSize: '24px'
    };
  }, [settings]);

  const onClearClick = () => {
    inputElem.current.value = '';
    resetForm();
  };

  return (
    <div
      className={clsx(classes.autocompleteContainer, {
        [classes.hidden]: !isDanishAddress
      })}
    >
      <input
        placeholder={intl.formatMessage({ id: 'ADDRESS.ADD_PLACEHOLDER' })}
        ref={inputElem}
        type="text"
      />
      <CustomIconButton
        onClick={onClearClick}
        iconClassName="far fa-window-close"
        customStyles={iconCustomStyles}
      />
    </div>
  );
}

export default flowRight(
  withSettings,
  injectIntl,
  withStyles(styles)
)(DawaAutocomplete);
